import { useState } from 'react'

import { signUp } from '@builddocs/data-management'
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from '@builddocs/mui'
import { VisuallyHiddenInput } from '@chakra-ui/react'
import { CloudUpload } from '@mui/icons-material'
import { CircularProgress, Stack, Typography } from '@mui/material'
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'

const AddUsersModal = () => {
  const [modalOpened, setModalOpened] = useState(false)
  const [progress, setProgress] = useState<null | string>(null)
  const [uploadedFile, setUploadedFile] = useState<null | File>(null)
  const [isFileProcessed, setIsFileProcessed] = useState(false)
  const [newFile, setNewFile] = useState<Blob | null>(null)

  const handleFileSelection = event => {
    const file = event.target.files[0]

    setUploadedFile(file || null)
    setIsFileProcessed(false)
    setProgress(null)
    setNewFile(null)
  }

  const handleRegistration = async () => {
    if (!uploadedFile) return

    try {
      setProgress('Читаем Excel файл...')
      const data = await uploadedFile.arrayBuffer()
      const workbook = XLSX.read(data, { type: 'array', cellStyles: true })
      const sheet = workbook.Sheets[workbook.SheetNames[0]]

      const originalSheet = workbook.Sheets[workbook.SheetNames[0]]

      const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' })

      const updatedRows = rows.map(row => {
        // @ts-expect-error затычка
        const newRow = { ...row }
        const statusKey = 'Статус регистрации'

        if (!newRow['Застройщик']) {
          newRow[statusKey] = ''
        } else {
          const keys = Object.keys(newRow)
          const newRowOrdered = {}

          keys.forEach(key => {
            newRowOrdered[key] = newRow[key]
            if (key === 'Застройщик') {
              newRowOrdered[statusKey] = ''
            }
          })
          return newRowOrdered
        }
        return newRow
      })

      setProgress(`Обрабатываем ${rows.length} пользователей...`)

      for (let i = 0; i < rows.length; i++) {
        console.log('сейчас итерация', i)
        // @ts-expect-error затычка
        console.log('USER**', 'EMPTY', rows[i]['Номер телефона (Обязательно)'])
        setProgress(`Регистрируем пользователя ${i + 1} из ${rows.length}...`)
        const user = {
          // @ts-expect-error затычка
          firstName: rows[i]['Имя (Обязательно)'],
          // @ts-expect-error затычка
          middleName: rows[i]['Отчество'],
          // @ts-expect-error затычка
          lastName: rows[i]['Фамилия (Обязательно)'],
          // @ts-expect-error затычка
          email: rows[i]['Почта (Обязательно)'].toLowerCase(),
          // @ts-expect-error затычка
          phone: `+${String(rows[i]['Номер телефона (Обязательно)'])?.replace(
            /[^0-9]/g,
            '',
          )}`,
          // @ts-expect-error затычка
          password: rows[i]['Пароль (Обязательно)'],
        }

        try {
          await signUp(user)
          updatedRows[i]['Статус регистрации'] = 'удалось'
        } catch (err) {
          // @ts-expect-error затычка
          if (err.response && err.response.status === 409) {
            // @ts-expect-error затычка
            const serverMessage = err.response.data.message

            if (serverMessage?.includes('already exists')) {
              updatedRows[i]['Статус регистрации'] =
                'не удалось: номер пользователя уже есть в системе'
            } else {
              updatedRows[i]['Статус регистрации'] =
                'не удалось: конфликт данных'
            }
          } else {
            updatedRows[i]['Статус регистрации'] = 'не удалось: ошибка сервера'
          }
        }
      }

      const cleanRows = updatedRows.map(row => {
        const cleanedRow = {}

        Object.keys(row).forEach(key => {
          if (!key.startsWith('__EMPTY')) {
            cleanedRow[key] = row[key]
          }
        })
        return cleanedRow
      })

      const newSheet = XLSX.utils.json_to_sheet(cleanRows, {
        header: Object.keys(cleanRows[0]),
      })

      newSheet['!cols'] = originalSheet['!cols']
      newSheet['!rows'] = originalSheet['!rows']

      // @ts-expect-error затычка
      const range = XLSX.utils.decode_range(newSheet['!ref'])

      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = { r: rowNum, c: colNum }
          const cellRef = XLSX.utils.encode_cell(cellAddress)
          const originalCell = originalSheet[cellRef]

          if (originalCell) {
            newSheet[cellRef] = {
              ...newSheet[cellRef],
              s: originalCell.s,
            }
          }
        }
      }

      const newWorkbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(newWorkbook, newSheet, 'Результаты')

      const excelBuffer = XLSX.write(newWorkbook, {
        bookType: 'xlsx',
        type: 'array',
        cellStyles: true,
      })

      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })

      setNewFile(blob)
      setIsFileProcessed(true)
      setProgress('Процесс завершен. Файл с результатами готов.')
    } catch (err) {
      console.error('Ошибка обработки файла:', err)
      setProgress('Ошибка при чтении Excel файла.')
    }
  }

  const handleClearState = () => {
    setUploadedFile(null)
    setIsFileProcessed(false)
    setProgress(null)
    setNewFile(null)
  }

  const handleDownload = () => {
    if (newFile) {
      saveAs(newFile, 'Результаты регистрации.xlsx')
    }
  }

  return (
    <>
      <Button
        style={{ backgroundColor: 'purple', color: 'white' }}
        onClick={() => setModalOpened(true)}
      >
        Добавить пользователей
      </Button>
      <Modal open={modalOpened} onClose={() => setModalOpened(false)}>
        <ModalContent sx={{ width: 300 }}>
          <ModalHeader onClose={() => setModalOpened(false)}>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.87)',
              }}
            >
              Создать пользователей
            </Typography>
          </ModalHeader>
          <ModalBody>
            <Stack direction="column" gap={2}>
              {progress ? (
                <Typography>{progress}</Typography>
              ) : (
                <Typography>Тут будем писать активную задачу</Typography>
              )}
              <Button
                component="label"
                role={undefined}
                startIcon={<CloudUpload />}
                tabIndex={-1}
                variant="contained"
              >
                Загрузить exel файл
                <VisuallyHiddenInput
                  accept=".xlsx, .xls"
                  type="file"
                  onChange={handleFileSelection}
                />
              </Button>
              {uploadedFile && !isFileProcessed && (
                <Button
                  disabled={!uploadedFile}
                  style={{
                    backgroundColor: uploadedFile ? 'blue' : 'grey',
                    color: 'white',
                  }}
                  onClick={handleRegistration}
                >
                  {progress ? (
                    <CircularProgress size={24} style={{ marginRight: 8 }} />
                  ) : (
                    'Начать регистрацию'
                  )}
                </Button>
              )}
              {isFileProcessed && (
                <>
                  <Button
                    style={{ backgroundColor: 'green', color: 'white' }}
                    variant="outlined"
                    onClick={handleDownload}
                  >
                    Скачать созданный Excel
                  </Button>
                  <Button
                    style={{ backgroundColor: 'red', color: 'white' }}
                    variant="outlined"
                    onClick={handleClearState}
                  >
                    Очистить состояние
                  </Button>
                </>
              )}
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AddUsersModal
